import { isPremiumCheckoutConfigured } from "../constants/premiumPlans";

function getSupabaseBaseUrl() {
  return process.env.REACT_APP_SUPABASE_URL?.replace(/\/$/, "") || "";
}

function getCheckoutFunctionUrl() {
  const base = getSupabaseBaseUrl();
  if (!base) return "";
  return `${base}/functions/v1/create-checkout-session`;
}

function getSyncFunctionUrl() {
  const base = getSupabaseBaseUrl();
  if (!base) return "";
  return `${base}/functions/v1/sync-subscription`;
}

function getPortalFunctionUrl() {
  const base = getSupabaseBaseUrl();
  if (!base) return "";
  return `${base}/functions/v1/create-portal-session`;
}

function getCheckoutSecret() {
  return process.env.REACT_APP_STRIPE_CHECKOUT_SECRET || "";
}

function getSupabaseAnonKey() {
  return process.env.REACT_APP_SUPABASE_ANON_KEY || "";
}

export function canStartStripeCheckout() {
  return isPremiumCheckoutConfigured() && Boolean(getCheckoutSecret() && getSupabaseAnonKey());
}

async function postCheckoutFunction(functionUrl, body) {
  const secret = getCheckoutSecret();
  const anonKey = getSupabaseAnonKey();
  if (!functionUrl || !secret || !anonKey) {
    throw new Error("Checkout is not configured yet.");
  }

  const response = await fetch(functionUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${anonKey}`,
      "x-checkout-secret": secret,
    },
    body: JSON.stringify(body),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || payload.message || "Checkout request failed.");
  }

  return payload;
}

export async function startStripeCheckout({ priceId, userId }) {
  if (!priceId || !userId) {
    throw new Error("Missing checkout configuration.");
  }

  const payload = await postCheckoutFunction(getCheckoutFunctionUrl(), {
    priceId,
    userId,
    successUrl: `${window.location.origin}/shop?checkout=success`,
    cancelUrl: `${window.location.origin}/shop?checkout=cancel`,
  });

  if (!payload.url) {
    throw new Error("Checkout session did not return a redirect URL.");
  }

  window.location.href = payload.url;
}

export async function syncStripeSubscription(userId) {
  if (!userId) {
    throw new Error("Missing user id.");
  }

  return postCheckoutFunction(getSyncFunctionUrl(), { userId });
}

export async function startStripeBillingPortal({ userId, returnUrl }) {
  if (!userId) {
    throw new Error("Missing user id.");
  }

  const payload = await postCheckoutFunction(getPortalFunctionUrl(), {
    userId,
    returnUrl: returnUrl || `${window.location.origin}/settings`,
  });

  if (!payload.url) {
    throw new Error("Billing portal did not return a redirect URL.");
  }

  window.location.href = payload.url;
}
